import {
  LadyIntroductionVideo,
  LadyOwnPhotoRaw,
  LadyProfileDtoRaw,
} from "../models";

export const isPhoto = (
  item: LadyProfileDtoRaw["forms"]["media"][number],
): item is LadyOwnPhotoRaw => {
  return LadyOwnPhotoRaw.safeParse(item).success;
};

export const isIntroVideo = (
  item: LadyProfileDtoRaw["forms"]["media"][number],
): item is LadyIntroductionVideo => {
  return LadyIntroductionVideo.safeParse(item).success;
};
